import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mail",
  "use": "icon-mail-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"icon-mail\"><path d=\"M43.5 7.5h-39C3.67 7.5 3 8.17 3 9v30c0 .83.67 1.5 1.5 1.5h39c.83 0 1.5-.67 1.5-1.5V9c0-.83-.67-1.5-1.5-1.5zm-1.875 5.194v24.431H6.375V12.694l-1.294-1.008 1.842-2.367 2.007 1.56h30.145l2.006-1.56 1.842 2.367-1.298 1.008zm-2.55-1.819L24 22.594 8.925 10.875l-2.006-1.56-1.842 2.366L6.37 12.69l16.013 12.45a2.625 2.625 0 003.22 0l16.022-12.445 1.294-1.008-1.842-2.367-2.002 1.556z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol